import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { useEffect } from 'react';
import { jsx } from '@emotion/core';
import { getPageLayoutSlotSelector } from '../../common/utils';
import { useSkipLinks } from '../../controllers';
import { mainStyles } from './styles';

var Main = function Main(props) {
  var children = props.children,
      testId = props.testId,
      id = props.id,
      skipLinkTitle = props.skipLinkTitle;

  var _useSkipLinks = useSkipLinks(),
      registerSkipLink = _useSkipLinks.registerSkipLink,
      unregisterSkipLink = _useSkipLinks.unregisterSkipLink;

  useEffect(function () {
    return function () {
      unregisterSkipLink(id);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (id && skipLinkTitle) {
    registerSkipLink({
      id: id,
      skipLinkTitle: skipLinkTitle
    });
  }

  return jsx("div", _extends({
    "data-testid": testId,
    css: mainStyles,
    id: id
  }, getPageLayoutSlotSelector('main')), children);
};

export default Main;